import RateBlock from './RateBlock.vue'

export default RateBlock
